import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get Campuses
export const GetCampuses = createAsyncThunk('campuses', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/campuses-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OtherCampuses = createAsyncThunk('other-campuses', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/other-campuses')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OtherCampusPro = createAsyncThunk(
  'other-campus-programs',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/general/other-campus-programs/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ScoreScales = createAsyncThunk('score-scales', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/score-scales`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Start Impersonation
export const StartImpersonate = createAsyncThunk(
  'start-impersonate',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/general/start-impersonate', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response)
      }
    }
  }
)

// Stop Impersonation
export const StopImpersonate = createAsyncThunk('stop-impersonate', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/general/stop-impersonate', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Sections
export const GetSections = createAsyncThunk('sections', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/sections-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get campus ProgramLevels
export const GetProgramLevels = createAsyncThunk('program-levels', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/program-levels-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ProgramLevels = createAsyncThunk('program-levels', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/program-levels')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get ProgramYears
export const GetProgramYears = createAsyncThunk('program-years', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/program-years-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Programs
export const GetPrograms = createAsyncThunk('programs', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/programs-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Genders
export const GetGenders = createAsyncThunk('genders', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/genders-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Countries
export const GetCountries = createAsyncThunk('countries', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/countries-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetCourses
export const GetCourses = createAsyncThunk('courses', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/courses-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetRegulationCategories
export const GetRegulationCategories = createAsyncThunk(
  'regulation-categories',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get('/api/general/regulation-categories-list')
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// getCurrencies
export const GetCurrencies = createAsyncThunk('currencies', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/currencies-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetCampusCurrencies
export const GetCampusCurrencies = createAsyncThunk('campus-currencies', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/campus-currencies-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetAcademicYears
export const GetAcademicYears = createAsyncThunk('academic-years', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/academic-years-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetIntakes
export const GetIntakes = createAsyncThunk('intakes', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/intakes-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetOrganizations
export const GetOrganizations = createAsyncThunk('organizations', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/organizations-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetPublicationFields
export const GetPublicationFields = createAsyncThunk('publication-fields', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/publication-fields-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetPublicationCategories
export const GetPublicationCategories = createAsyncThunk(
  'publication-categories',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get('/api/general/publication-categories-list')
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// GetVideoCategories
export const GetVideoCategories = createAsyncThunk('video-categories', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/video-categories-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetRecurringFrequencies
export const GetFormTypes = createAsyncThunk('form-types', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/form-types-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// GetRecurringFrequencies
export const GetBanks = createAsyncThunk('banks', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/banks-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSemesters = createAsyncThunk('semesters', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/semesters-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetVideos = createAsyncThunk('videos', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/videos-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStudents = createAsyncThunk('students', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/general/students-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Notifications = createAsyncThunk('notifications', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/notifications`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ReadNotification = createAsyncThunk('read-notify', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/read-notification/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const RelatedNotification = createAsyncThunk(
  'related-notification',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/general/related-notifications/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GeneralStatistics = createAsyncThunk('gen-statistics', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/general/general-statistics`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetOnlineProps = createAsyncThunk('online-props', async (lang: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/get-props/${lang}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const RelatedIntakes = createAsyncThunk(
  'related-intakes',
  async (proId: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/related-intakes/${proId}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SubmitOnlineApplication = createAsyncThunk(
  'submit-online-application',
  async (data: FormData, thunkAPI) => {
    try {
      const response = await axios.post('/api/online-app-submit', data)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data ?? {
          message: 'Server error',
        }
      )
    }
  }
)

export const SubmitKankorApp = createAsyncThunk(
  'submit-kank-app',
  async (data: FormData, thunkAPI) => {
    try {
      const response = await axios.post('/api/kankor-app-submit', data)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data ?? {
          message: 'Server error',
        }
      )
    }
  }
)
export const StoreOnlineCourseApp = createAsyncThunk(
  'online-course-app-store',
  async (data: FormData, thunkAPI) => {
    try {
      const response = await axios.post('/api/online-course-app-submit', data)
      return response.data
    } catch (error: any) {
      const responseData = error.response?.data

      return thunkAPI.rejectWithValue(responseData?.errors ?? responseData ?? 'ServerError')
    }
  }
)

export const GetOnlineCourses = createAsyncThunk(
  'get-goc',
  async ({lang, cid}: {lang: any; cid: any}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/get-online-courses/${lang}/${cid}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetTimeSlots = createAsyncThunk('time-slots', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/time-slots`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PlanningAcademicYears = createAsyncThunk('planning-ay', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/planning-academic-years`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const FinanceAcademicYears = createAsyncThunk('planning-ay', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/finance-academic-years`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type GeneralState = {
  general: any
  notification: any
}

const initialState: GeneralState = {
  general: [],
  notification: [],
}

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(GetCampuses.fulfilled, (state, action: PayloadAction<any>) => {
      state.general = action.payload
    })
    builder.addCase(Notifications.fulfilled, (state, action: PayloadAction<any>) => {
      state.notification = action.payload
    })
  },
})

export const {reset} = generalSlice.actions
export default generalSlice.reducer
